import Cookies from "js-cookie";
import {
  generateDeviceType,
  removeItem,
  setItem,
} from "../../helpers/data_management";
import { sendTrackingEvent } from "../../helpers/tracking_management";
import api from "../../utils/api";
import * as types from "../types/user_type";

const register =
  (params = {}) =>
  async (dispatch) => {
    const deviceType = generateDeviceType();

    const payload = {
      query: `
        mutation {
          webRegister(
            input: {name: "${params.name}", email: "${params.email}", password: "${params.password}", device_type: "${deviceType}", media_source: "${params.mediaSource}", pdpa_accepted:${params.pdpaAccepted}}
          ) {
            newUser
            user {
              id
              token
              pdpa_accepted
            }
          }
        }      
      `,
    };

    const registerRes = await api.apiCall("/api/v2/graphql", params, payload);

    if (registerRes.status === 200) {
      const { errors } = registerRes?.data;
      const { user, newUser } = registerRes?.data?.data?.webRegister || {};
      const { token } = user || {};

      if (newUser === false) {
        return dispatch({
          type: types.SIGNUP_FAILED,
          message: "Account already exist, please login instead",
        });
      }

      if (Array.isArray(errors) && errors.length > 0) {
        return dispatch({
          type: types.SIGNUP_FAILED,
          message: errors[0].message,
        });
      }

      if (!user || !token) {
        return dispatch({
          type: types.SIGNUP_FAILED,
        });
      }

      setItem(types.USER_PROFILE, JSON.stringify(user));
      setItem(types.USER_TOKEN, token);

      Cookies.set("userId", user?.id);

      return dispatch({
        type: types.SIGNUP_SUCCESS,
        payload: {
          user: user,
        },
      });
    }

    return dispatch({
      type: types.SIGNUP_FAILED,
    });
  };

const socialMediaLogin =
  (params = {}) =>
  (dispatch) => {
    // dispatch({ type: types.SOCIAL_LOGIN });
    const deviceType = generateDeviceType();

    const payload = {
      query: `
      mutation {
        socialMediaLogin(input: {device_type: "${deviceType}", provider: "${
        params.provider
      }", access_token: "${params.accessToken}", media_source: "${
        params.urlParams
      }", bio: "${params.referralToken ? params.referralToken : null}"}) {
        user {
          id
          name
          gender
          nationality
          resume
          email
          approved
          state
          token
          pdpa_accepted
        } 
        newUser
        }
      }
      `,
    };

    return api
      .apiCall("/api/v2/graphql", params, payload)
      .then(async (response) => {
        const user = response?.data?.data?.socialMediaLogin?.user;
        const newUser = response?.data?.data?.socialMediaLogin?.newUser;
        const token = response?.data?.data?.socialMediaLogin?.user?.token;

        if (user === null && newUser === null) {
          return dispatch({
            type: types.SIGNUP_FAILED,
            payload: {
              noEmail: true,
            },
          });
        }

        setItem(types.USER_PROFILE, JSON.stringify(user));
        setItem(types.USER_TOKEN, token);

        if (newUser) {
          Cookies.set("userId", user?.id);

          return dispatch({
            type: types.SIGNUP_SUCCESS,
            payload: {
              user: user,
            },
          });
        }

        if (newUser === false) {
          Cookies.set("userId", user?.id);

          return dispatch({
            type: types.LOGIN_SUCCESS,
            payload: {
              user: user,
            },
          });
        }

        return dispatch({
          type: types.LOGIN_FAILED,
        });
      });
  };

const login =
  (params = {}) =>
  (dispatch) => {
    if (!params.email || !params.password) return;

    const payload = {
      query: `
        mutation {
          login(input: {email: "${params.email}", password: "${params.password}"}) {
            user {
              id
              name
              profileImageSquare
              gender
              birthDate
              nationality
              mobileNumber
              currentCompany
              shortSummary
              resume
              email
              approved
              state
              pdpaAccepted
            }
            token
          }
        }    
      `,
    };

    return api
      .apiCall("/api/job_seeker/v1/graphql", params, payload)
      .then(async (response) => {
        if (response.status === 200) {
          const { errors } = response?.data;

          if (Array.isArray(errors) && errors.length > 0) {
            return dispatch({
              type: types.LOGIN_FAILED,
              errMsg: errors[0]?.message,
            });
          }

          const { user, token } = response?.data?.data?.login;

          if (user && token) {
            setItem(types.USER_PROFILE, JSON.stringify(user));
            setItem(types.USER_TOKEN, token);

            setItem(types.CLEVERTAP_INIT, "true"); // Store CleverTap initialization status once the user logs in

            Cookies.set("userId", user?.id);

            sendTrackingEvent({
              event: "CE_login",
              method: "email",
            });

            return dispatch({
              type: types.LOGIN_SUCCESS,
              payload: { user },
            });
          }
          return dispatch({
            type: types.LOGIN_FAILED,
          });
        }
        return dispatch({
          type: types.LOGIN_FAILED,
        });
      });
  };

const logout = () => (dispatch) => {
  removeItem(types.USER_TOKEN);
  removeItem(types.USER_PROFILE);
  localStorage.removeItem("resume_onboarding");
  Cookies.remove("userId");

  sendTrackingEvent({
    event: "CE_logout",
  });

  return dispatch({ type: types.LOGOUT });
};

const getUser = () => {
  let user = {};
  try {
    user = JSON.parse(localStorage.getItem(types.USER_PROFILE));
  } catch (error) {
    //
  }

  return user;
};

// resume
const getUserResumeBlob =
  (params = {}) =>
  async (dispatch) => {
    const payload = {
      query: `{ 
        downloadResume
      }
      `,
    };

    return api
      .apiCall("/api/job_seeker/v1/graphql", params, payload)
      .then(async (response) => {
        if (response.status === 200) {
          const { resume, filename } = response?.data?.data?.downloadResume;

          if (resume) {
            return dispatch({
              type: types.GET_RESUME_SUCCESS,
              resumeBlob: resume,
              resumeFilename: filename,
            });
          } else {
            return dispatch({
              type: types.GET_RESUME_FAILED,
            });
          }
        } else {
          return dispatch({
            type: types.GET_RESUME_FAILED,
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: types.GET_RESUME_FAILED,
        });
      });
  };

const uploadResume = (params) => async (dispatch) => {
  const payload = {
    query: `
      mutation {
        resumeUpload(input: {resume: "${params.resume}", state: "${params.state}"}) {
          message
          success
          user {
            resume
            approved
            state
            pdpaAccepted
          }
        }
      }    
    `,
  };

  const response = await api.apiCall(
    "/api/job_seeker/v1/graphql",
    params,
    payload
  );

  if (response?.status === 200) {
    const { errors } = response?.data || {};
    const { resumeUpload } = response?.data?.data || {};

    if (Array.isArray(errors) && errors.length > 0 && errors[0]?.message) {
      return dispatch({
        type: types.UPLOAD_RESUME_FAILED,
      });
    }

    const { success, user: _user } = resumeUpload || {};

    if (!success || !_user) {
      return dispatch({
        type: types.UPLOAD_RESUME_FAILED,
      });
    }

    let localUser = JSON.parse(localStorage.getItem(types.USER_PROFILE));
    localUser.resume = _user?.resume;
    localStorage.setItem(types.USER_PROFILE, JSON.stringify(localUser));

    return dispatch({
      type: types.UPLOAD_RESUME_SUCCESS,
      payload: {
        user: _user,
      },
    });
  }

  return dispatch({
    type: types.UPLOAD_RESUME_FAILED,
  });
};

const getUserInfo = (params) => async (dispatch) => {
  const payload = {
    query: `
      {
        me {
          id
          email
          name
          profileImageSquare
          gender
          birthDate
          nationality
          mobileNumber
          currentCompany
          shortSummary
          resume
          approved
          state
          pdpaAccepted
          major
          checkEmpty
          onboarding
          skills {
            id
            title
            titleBm
            freeText
          }
          languages {
            id
            title
            titleBm
          }
          educations {
            educationLevel
            educationalInstitution {
              id
              name
            }
            fieldOfStudy
            graduationYear
            id
            major
          }
          workingExperiences {
              cityShoppingMall
              companyName
              endDate
              industry {
                id
                title
                titleBm
              }
              isActiveEmployee
              jobDescription
              jobTitle {
                id
                title
                titleBm
              }
              startDate
              stateRegion
          }
          profile {
            cityShoppingMall
            id
            stateRegion
          }
        }
      }    
    `,
  };

  const response = await api.apiCall(
    "/api/job_seeker/v1/graphql",
    params,
    payload
  );
  if (response.status === 200) {
    const { me } = response.data?.data;

    const { errors } = response.data;
    if (me && !errors) {
      // replace localStorage user object to latest user object
      setItem(types.USER_PROFILE, JSON.stringify(me));

      return dispatch({
        type: types.GET_USER_INFO_SUCCESS,
        payload: {
          user: me,
        },
      });
    }
    return dispatch({
      type: types.GET_USER_INFO_FAILED,
    });
  }
  return dispatch({
    type: types.GET_USER_INFO_FAILED,
  });
};

const formatEducation = (educations) => {
  return educations
    .map((education) => {
      const educationalInstitution =
        typeof education.educationalInstitution === "object"
          ? education.educationalInstitution.name
          : education.educationalInstitution;

      return `{
      educationLevel: "${education.educationLevel.replace(/"/g, '\\"') || ""}",
      educationalInstitution: "${
        educationalInstitution.replace(/"/g, '\\"') || ""
      }",
      fieldOfStudy: "${education.fieldOfStudy.replace(/"/g, '\\"') || ""}",
      graduationYear: ${parseInt(education.graduationYear, 10) || 0}, 
      major: "${education.major.replace(/"/g, '\\"') || ""}"
    }`;
    })
    .join(",\n");
};

const updateEducation = (params) => async (dispatch) => {
  const formattedEducations = formatEducation(params.education);

  const payload = {
    query: `
    mutation {
      saveEducations(
      input: {educations: [${formattedEducations}]}
      ) {
        success
        educations {
          id
          graduationYear
          educationLevel
          description
          educationalInstitution {
            id
            name
          }
          fieldOfStudy
          major
        }
      }
    }    
    `,
  };

  const response = await api.apiCall(
    "/api/job_seeker/v1/graphql",
    params,
    payload
  );

  // if response is 200, we still need to chekc for errors and success flag
  if (response.status === 200) {
    const { saveEducations } =
      response?.data?.data?.saveEducations?.educations || {};
    const { success, educations } = saveEducations || {};
    const responseSuccess = response?.data?.data?.saveEducations?.success;

    const { errors } = response?.data || {};

    if (!responseSuccess) {
      return dispatch({
        type: types.SAVE_EDUCATION_FAILED,
      });
    } else {
      return dispatch({
        type: types.SAVE_EDUCATION_SUCCESS,
        payload: saveEducations,
        // {
        //   latestEducation: saveEducations,
        // },
      });
    }
  }

  // if status is not 200, we straight away return save education failed state
  return dispatch({
    type: types.SAVE_EDUCATION_FAILED,
  });
};

const formatWorkExperience = (workExps) => {
  return workExps
    .map((workExp) => {
      return `{
        companyName: "${workExp.companyName.replace(/"/g, '\\"') || ""}",
        industryId: ${workExp.industry ? workExp.industry.id : "null"},
        isActiveEmployee: ${workExp.isActiveEmployee},
        jobDescription: "${workExp.jobDescription.replace(/"/g, '\\"') || ""}",
        jobTitleId: ${workExp.jobTitle ? workExp.jobTitle.id : "null"},
        startDate: "${workExp.startDate || ""}",
        endDate: "${workExp.endDate || workExp.startDate}",
        cityShoppingMall: "${workExp.cityShoppingMall || ""}",
        stateRegion: "${workExp.stateRegion || ""}"
    }`;
    })
    .join(",\n");
};

const updateWorkExperiences = (params) => async (dispatch) => {
  const formattedWorkExperience = formatWorkExperience(params.workExperiences);

  const payload = {
    query: `
    mutation {
      saveWorkingExperiences(
      input: {workingExperiences: [${formattedWorkExperience}]}
      ) {
        success
        workingExperiences {
          cityShoppingMall
          companyName
          endDate
          experience {
            id
          }
          industry {
            title
            id
            titleBm
          }
          isActiveEmployee
          jobDescription
          jobTitle {
            id
            title
            titleBm
          }
          startDate
          stateRegion
        }
      }
    }    
    `,
  };

  const response = await api.apiCall(
    "/api/job_seeker/v1/graphql",
    params,
    payload
  );

  // if response is 200, we still need to chekc for errors and success flag
  if (response.status === 200) {
    const { workingExperiences } =
      response?.data?.data?.saveWorkingExperiences?.workingExperiences || {};
    const { success, work } = workingExperiences || {};
    const responseSuccess =
      response?.data?.data?.saveWorkingExperiences?.success;

    const { errors } = response?.data || {};

    if (!responseSuccess) {
      return dispatch({
        type: types.SAVE_WORK_EXPERIENCE_FAILED,
      });
    } else {
      return dispatch({
        type: types.SAVE_WORK_EXPERIENCE_SUCCESS,
        payload: {
          latestWorkExperience: work,
        },
      });
    }
  }

  // if status is not 200, we straight away return save education failed state
  return dispatch({
    type: types.SAVE_WORK_EXPERIENCE_FAILED,
  });
};

const updateProfile = (params) => async (dispatch) => {
  const nameParams = params.name ? `name: "${params.name}",` : "";
  const genderParams = params.gender ? `gender : "${params.gender}",` : "";
  const birthDateParams = params.birthDate
    ? `birthDate: "${params.birthDate}",`
    : "";
  const mobileNumberParams = params.mobileNumber
    ? `mobileNumber: "${params.mobileNumber}",`
    : "";
  const currentCompanyParams = params.currentCompany
    ? `currentCompany: "${params.currentCompany}",`
    : "";
  const pdpaAcceptedParams = params.pdpaAccepted
    ? `pdpaAccepted: ${params.pdpaAccepted},`
    : "";
  const shortSummaryParams = params.shortSummary
    ? `shortSummary: "${params.shortSummary}",`
    : "";
  const nationalityParams = params.nationality
    ? `nationality: "${params.nationality}",`
    : "";
  const stateRegionParams = params.stateRegion
    ? `stateRegion: "${params.stateRegion}",`
    : "";
  const cityShoppingMallParams = params.cityShoppingMall
    ? `cityShoppingMall: "${params.cityShoppingMall}",`
    : "";

  const queryInput = `${nameParams} ${genderParams} ${birthDateParams} ${mobileNumberParams} ${currentCompanyParams} ${pdpaAcceptedParams} ${shortSummaryParams} ${nationalityParams} ${cityShoppingMallParams} ${stateRegionParams}
  `;

  const payload = {
    query: `
      mutation {
        saveProfile(input: {${queryInput}}) {
          success
          user {
            name
            gender
            birthDate
            nationality
            mobileNumber
            currentCompany
            shortSummary
            major
            pdpaAccepted
            checkEmpty
            onboarding
            profile {
                id
                cityShoppingMall
                stateRegion
            }
          }
        }
      }    
    `,
  };

  const response = await api.apiCall(
    "/api/job_seeker/v1/graphql",
    params,
    payload
  );

  if (response.status === 200) {
    const { user, success } = response?.data?.data?.saveProfile || {};
    const { errors } = response?.data || {};

    if (errors || success === false) {
      return dispatch({
        type: types.SAVE_BASIC_INFO_FAILED,
      });
    }

    let localUser = JSON.parse(localStorage.getItem(types.USER_PROFILE));
    localUser.name = user.name;
    localUser.gender = user.gender;
    localUser.birthDate = user.birthDate;
    localUser.nationality = user.nationality;
    localUser.mobileNumber = user.mobileNumber;
    localUser.currentCompany = user.currentCompany;
    localUser.shortSummary = user.shortSummary;
    localUser.onboarding = user.onboarding;
    localUser.major = user.major;
    localUser.profile = user.profile;
    localStorage.setItem(types.USER_PROFILE, JSON.stringify(localUser));

    return dispatch({
      type: types.SAVE_BASIC_INFO_SUCCESS,
      payload: {
        latestUser: { ...user },
      },
    });
  }

  return dispatch({
    type: types.SAVE_BASIC_INFO_FAILED,
  });
};

const updateProfileImage = (params) => async (dispatch) => {
  const payload = {
    query: `
      mutation {
        saveProfile(
          input: {profileImage: "${params.profileImage}"}
        ) {
          success
          user {
            profileImageSquare
          }
        }
      }    
    `,
  };

  const response = await api.apiCall(
    "/api/job_seeker/v1/graphql",
    params,
    payload
  );

  if (response.status === 200) {
    const { user, success } = response?.data?.data?.saveProfile || {};
    const { errors } = response?.data || {};

    if (errors || success === false) {
      return dispatch({
        type: types.SAVE_PROFILE_IMAGE_FAILED,
      });
    }

    let localUser = JSON.parse(localStorage.getItem(types.USER_PROFILE));
    localUser.profileImageSquare = user.profileImageSquare;
    localStorage.setItem(types.USER_PROFILE, JSON.stringify(localUser));

    return dispatch({
      type: types.SAVE_PROFILE_IMAGE_SUCCESS,
      payload: {
        latestUser: { ...user },
      },
    });
  }

  return dispatch({
    type: types.SAVE_PROFILE_IMAGE_FAILED,
  });
};

const forgotPassword = (params) => async (dispatch) => {
  const payload = {
    query: `
    mutation{
      forgotPassword(input: { email: "${params.email}"}) {
        result
      }
    }
    `,
  };

  const response = await api.apiCall("/api/v2/graphql", params, payload);

  if (response.status === 200) {
    const { result } = response?.data?.data?.forgotPassword;

    if (result === true) {
      return dispatch({
        type: types.FORGOT_PASSWORD_RESET_SUCCESS,
      });
    }
    return dispatch({
      type: types.FORGOT_PASSWORD_RESET_FAILED,
    });
  }
  return dispatch({
    type: types.FORGOT_PASSWORD_RESET_SUCCESS,
  });
};

const submitContactUsForm =
  (params = {}) =>
  async (dispatch) => {
    const payload = {
      query: `
        mutation {
          sendEnquiryEmail(input: {email: "${params.email}", message: "${params.message}", serviceInterested: []}) {
            enquiryEmailSent
          }
        }
      `,
    };

    const response = await api.apiCall(
      "/api/job_seeker/v1/graphql",
      params,
      payload
    );

    if (response.status === 200) {
      const { enquiryEmailSent } = response.data?.data?.sendEnquiryEmail;

      if (enquiryEmailSent === true) {
        return dispatch({
          type: types.SUBMIT_CONTACT_US_SUCCESS,
        });
      }
      return dispatch({
        type: types.SUBMIT_CONTACT_US_FAILED,
      });
    }
    return dispatch({
      type: types.SUBMIT_CONTACT_US_FAILED,
    });
  };

const submitEmployerContactUsForm =
  (params = {}) =>
  async (dispatch) => {
    let nameInput = params.name ? `name: "${params.name}",` : "";
    let companyNameInput = params.companyName
      ? `companyName: "${params.companyName}",`
      : "";
    let emailInput = params.email ? `email: "${params.email}",` : "";
    let phoneInput = params.phone ? `phoneNumber: "${params.phone}",` : "";
    let subjectInput = params.subject ? `subject: "${params.subject}",` : "";
    let messageInput = params.message ? `message: "${params.message}",` : "";
    let originInput = params.origin ? `origin: "${params.origin}",` : "";
    let servicesInput = params.services
      ? `serviceInterested: ${JSON.stringify(params.services)},`
      : "";

    let queryInput =
      nameInput +
      companyNameInput +
      emailInput +
      phoneInput +
      subjectInput +
      messageInput +
      originInput +
      servicesInput;

    // Removing trailing ","
    if (queryInput.charAt(queryInput.length - 1) == ",") {
      queryInput = queryInput.substring(0, queryInput.length - 1);
    }

    const payload = {
      query: `
        mutation {
          sendEnquiryEmail(
            input: {${queryInput}}
          ) {
            enquiryEmailSent
          }
        }
      `,
    };

    try {
      const result = await api.apiCall(
        "/api/job_seeker/v1/graphql",
        params,
        payload
      );

      if (result.status === 200) {
        const { enquiryEmailSent } = result.data?.data?.sendEnquiryEmail;

        if (enquiryEmailSent) {
          return dispatch({
            type: types.SUBMIT_CONTACT_US_SUCCESS,
          });
        }
      }

      return dispatch({
        type: types.SUBMIT_CONTACT_US_FAILED,
      });
    } catch (e) {
      return dispatch({
        type: types.SUBMIT_CONTACT_US_FAILED,
      });
    }
  };

const resetPassword =
  (params = {}) =>
  (dispatch) => {
    const payload = {
      secret: `
      mutation {
        resetPassword(input: {password: "${params.password}", token: "${params.token}"}) {
          result
          message
        }
      }
    `,
    };

    return api
      .apiCall("/api/v2/graphql", params, payload)
      .then(async (response) => {
        if (response.status === 200) {
          const { result, message } = response.data?.data?.resetPassword;
          if (result) {
            return dispatch({
              type: types.RESET_PASSWORD_SUCCEED,
              result: result,
              message: message,
            });
          } else {
            return dispatch({
              type: types.RESET_PASSWORD_FAILED,
              result: result,
              message: message,
            });
          }
        }
        return { type: types.RESET_PASSWORD_FAILED };
      })
      .catch((error) => {
        return { type: types.RESET_PASSWORD_FAILED };
      });
  };

const checkPDPAStatus =
  (params = {}) =>
  async (dispatch) => {
    const payload = {
      query: `{
      me {
        pdpaAccepted
      }
    }      
    `,
    };

    return api
      .apiCall("/api/job_seeker/v1/graphql", params, payload)
      .then(async (response) => {
        if (response.status === 200) {
          if (response?.data?.data?.me != null) {
            const pdpaAccepted = response?.data?.data?.me?.pdpaAccepted;

            return dispatch({
              type: types.FETCH_PDPA_STATUS_SUCCESS,
              payload: pdpaAccepted,
            });
          }
        }
      });
  };

const updatePDPAStatus =
  (params = {}) =>
  async (dispatch) => {
    const payload = {
      query: `mutation {
        saveProfile(input: {pdpaAccepted: true}) {
          user{
            pdpaAccepted
          }
        }
      }`,
    };

    return api
      .apiCall("/api/job_seeker/v1/graphql", params, payload)
      .then((response) => {
        if (response.status === 200) {
          const { pdpaAccepted } = response?.data?.data?.saveProfile.user;
          if (pdpaAccepted) {
            return dispatch({
              type: types.FETCH_PDPA_STATUS_SUCCESS,
              payload: pdpaAccepted,
            });
          } else {
            return dispatch({
              type: types.UPDATE_PDPA_STATUS_FAILED,
            });
          }
        } else {
          return dispatch({
            type: types.UPDATE_PDPA_STATUS_FAILED,
          });
        }
      });
  };

const updateOnboardingStatus =
  (params = {}) =>
  async (dispatch) => {
    const payload = {
      query: `mutation {
        saveProfile(input: {onboarding: true}) {
          user{
            onboarding
          }
        }
      }`,
    };

    return api
      .apiCall("/api/job_seeker/v1/graphql", params, payload)
      .then((response) => {
        if (response.status === 200) {
          const { onboarding } = response?.data?.data?.saveProfile.user;
          if (onboarding) {
            return dispatch({
              type: types.UPDATE_ONBOARDING_SUCCESS,
              payload: onboarding,
            });
          } else {
            return dispatch({
              type: types.UPDATE_ONBOARDING_FAILED,
            });
          }
        } else {
          return dispatch({
            type: types.UPDATE_ONBOARDING_FAILED,
          });
        }
      });
  };

const addWorkExperience = () => async (dispatch) => {
  return new Promise((resolve) => {
    return resolve(
      dispatch({
        type: types.ADD_WORK_EXPERIENCE,
      })
    );
  });
};

const removeWorkExperience = (index) => async (dispatch) => {
  return new Promise((resolve) => {
    return resolve(
      dispatch({
        type: types.REMOVE_WORK_EXPERIENCE,
        payload: index,
      })
    );
  });
};

const updateWorkExperience = (workExperiences) => async (dispatch) => {
  return new Promise((resolve) => {
    return resolve(
      dispatch({
        type: types.UPDATE_WORK_EXPERIENCE,
        payload: workExperiences,
      })
    );
  });
};

const addEducations = () => async (dispatch) => {
  return new Promise((resolve) => {
    return resolve(
      dispatch({
        type: types.ADD_EDUCATION,
      })
    );
  });
};

const removeEducations = (index) => async (dispatch) => {
  return new Promise((resolve) => {
    return resolve(
      dispatch({
        type: types.REMOVE_EDUCATION,
        payload: index,
      })
    );
  });
};

const updateEducations = (education) => async (dispatch) => {
  return new Promise((resolve) => {
    return resolve(
      dispatch({
        type: types.UPDATE_EDUCATION,
        payload: education,
      })
    );
  });
};

const updateSkills = (skills) => async (dispatch) => {
  return new Promise((resolve) => {
    return resolve(
      dispatch({
        type: types.UPDATE_SKILLS,
        payload: skills,
      })
    );
  });
};

const updateLanguage = (language) => async (dispatch) => {
  return new Promise((resolve) => {
    return resolve(
      dispatch({
        type: types.UPDATE_LANGUAGE,
        payload: language,
      })
    );
  });
};

const updateLeaveModal = (state) => async (dispatch) => {
  return new Promise((resolve) => {
    return resolve(
      dispatch({
        type: types.UPDATE_LEAVE_MODAL,
        payload: state,
      })
    );
  });
};

const updateUserProfileModal = (state) => async (dispatch) => {
  return new Promise((resolve) => {
    return resolve(
      dispatch({
        type: types.UPDATE_USER_PROFILE_MODAL,
        payload: state,
      })
    );
  });
};

const updateUserProfileContent = (edit, section, index) => async (dispatch) => {
  const profile = { edit, section, index };
  return new Promise((resolve) => {
    return resolve(
      dispatch({
        type: types.UPDATE_USER_PROFILE_DIALOG,
        payload: profile,
      })
    );
  });
};

const updateIsEdited = (state) => async (dispatch) => {
  return new Promise((resolve) => {
    return resolve(
      dispatch({
        type: types.UPDATE_IS_EDITED,
        payload: state,
      })
    );
  });
};

const getStateRegions =
  (params = {}) =>
  async (dispatch, getState) => {
    const payload = {
      query: `{
      stateRegions {
          id
          state
        }
      }      
    `,
    };

    return api
      .apiCall("/api/job_seeker/v1/graphql", params, payload)
      .then(async (response) => {
        if (response.status === 200) {
          const stateRegions = response.data.data.stateRegions;
          return dispatch({
            type: types.GET_STATEREGION_SUCCEEDED,
            payload: stateRegions,
          });
        } else {
          return dispatch({
            type: types.GET_STATEREGION_FAILED,
          });
        }
      })
      .catch((error) => {
        return dispatch({
          type: types.GET_STATEREGION_FAILED,
        });
      });
  };

const getLanguageOption = (params) => async (dispatch) => {
  const payload = {
    query: `
      {
        languages {
          id
          title
          titleBm
        }
      }    
    `,
  };

  return api
    .apiCall("/api/job_seeker/v1/graphql", params, payload)
    .then(async (response) => {
      if (response.status === 200) {
        const lang = response?.data;
        return dispatch({
          type: types.GET_LANGUAGE_SUCCEED,
          payload: lang,
        });
      }
    });
};

const saveLanguage =
  (params = {}) =>
  async (dispatch) => {
    const payload = {
      query: `mutation {
        saveLanguages(input: { languages: [${params.language}] }) {
        success
        languages {
        id
        title
        titleBm
        }
      }
      }`,
    };

    return api
      .apiCall("/api/job_seeker/v1/graphql", params, payload)
      .then((response) => {
        if (response.status === 200) {
          const isSaved = response?.data?.data?.saveLanguages?.success;
          const language = response?.data?.data?.saveLanguages?.languages;

          if (isSaved) {
            return dispatch({
              type: types.SAVE_LANGUAGE_SUCCESS,
              payload: language,
            });
          } else {
            return dispatch({
              type: types.SAVE_LANGUAGE_FAILED,
            });
          }
        } else {
          return dispatch({
            type: types.SAVE_LANGUAGE_FAILED,
          });
        }
      });
  };

const getSkillsOption = (params) => async (dispatch) => {
  const payload = {
    query: `
        {
          skills {
            id
            title
            titleBm
          }
        }    
      `,
  };

  return api
    .apiCall("/api/job_seeker/v1/graphql", params, payload)
    .then(async (response) => {
      if (response.status === 200) {
        const skills = response?.data;
        return dispatch({
          type: types.GET_SKILLS_SUCCEED,
          payload: skills,
        });
      }
    });
};

const saveSkills =
  (params = {}) =>
  async (dispatch) => {
    const skillsString = JSON.stringify(params.skills).replace(
      /"([^"]+)":/g,
      "$1:"
    );

    const payload = {
      query: `mutation {
         saveSkills(input: { skills: ${skillsString} }) {
          success
          skills {
          id
          title
          titleBm
          freeText
          }
        }
        }`,
    };

    return api
      .apiCall("/api/job_seeker/v1/graphql", params, payload)
      .then((response) => {
        if (response.status === 200) {
          const isSaved = response?.data?.data?.saveSkills?.success;
          const skills = response?.data?.data?.saveSkills?.skills;

          if (isSaved) {
            return dispatch({
              type: types.SAVE_SKILLS_SUCCESS,
              payload: skills,
            });
          } else {
            return dispatch({
              type: types.SAVE_SKILLS_FAILED,
            });
          }
        } else {
          return dispatch({
            type: types.SAVE_SKILLS_FAILED,
          });
        }
      });
  };

const getEducationInstitution = (params) => async (dispatch) => {
  let queryInput = `institutionName: ${JSON.stringify(params?.name)}`;
  const payload = {
    query: `
        {
          educationalInstitution(${queryInput}) {
            nodes {
              id
              name
            }
          }
        }    
      `,
  };

  return api
    .apiCall("/api/job_seeker/v1/graphql", params, payload)
    .then(async (response) => {
      if (response.status === 200) {
        const edu = response?.data?.data?.educationalInstitution?.nodes;
        return dispatch({
          type: types.GET_EDUCATION_INSTITUTION_SUCCEED,
          payload: edu,
        });
      }
    });
};

const getJobTitles = (params) => async (dispatch) => {
  const payload = {
    query: `
        {
          jobTitles {
            id
            title
            titleBm
          }
        }    
      `,
  };

  return api
    .apiCall("/api/job_seeker/v1/graphql", params, payload)
    .then(async (response) => {
      if (response.status === 200) {
        const jobTitles = response?.data?.data?.jobTitles;
        return dispatch({
          type: types.GET_JOB_TITLES_SUCCEED,
          payload: jobTitles,
        });
      }
    });
};

export {
  addEducations,
  addWorkExperience,
  checkPDPAStatus,
  forgotPassword,
  getEducationInstitution,
  getJobTitles,
  getLanguageOption,
  getSkillsOption,
  getStateRegions,
  getUser,
  getUserInfo,
  getUserResumeBlob,
  login,
  logout,
  register,
  removeEducations,
  removeWorkExperience,
  resetPassword,
  saveLanguage,
  saveSkills,
  socialMediaLogin,
  submitContactUsForm,
  submitEmployerContactUsForm,
  updateEducation,
  updateEducations,
  updateIsEdited,
  updateLanguage,
  updateLeaveModal,
  updateOnboardingStatus,
  updatePDPAStatus,
  updateProfile,
  updateProfileImage,
  updateSkills,
  updateUserProfileContent,
  updateUserProfileModal,
  updateWorkExperience,
  updateWorkExperiences,
  uploadResume,
};
